import { CROP_TYPE } from "../crop.types";
import { UmbracoImageCrop } from "../models/media.interface";

export default (crops: UmbracoImageCrop[] | undefined, preferredCropAlias?: string, cropFallback?: CROP_TYPE): UmbracoImageCrop | undefined => {
    let imageCrop = undefined;

    if (crops && crops.length > 0) {
        imageCrop = crops.find(crop => {
            if (preferredCropAlias) {
                return crop.alias === preferredCropAlias;
            }
            else if (cropFallback) {
                return crop.alias === cropFallback;
            }
            else {
                return crop.alias === "Fullscreen (4:3)";
            }
        });
    }

    return imageCrop;
};
